// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_RemoverCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /compromissos/remover_compromisso/{id}
 *
 * Removes an appointment and reverts its services to "Aguardando".
 * Returns null dados — operation success is signaled by the envelope's
 * `success` flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Compromissos_RemoverCompromissoResponseDados = null;

export type Compromissos_RemoverCompromissoResponse = ApiResponse<Compromissos_RemoverCompromissoResponseDados>;

registerResponseContract('Compromissos_RemoverCompromissoResponse', {})
